import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { postChannel } from '../../../api/channels';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { mergeChannelWithUserData } from '../../../utils/channels';

import { REQUEST } from '../../../constants/request';

export const createChannel = createAsyncThunk(
  'channels/createChannel',
  async ({ path, body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [channelResponse, channelUserDataResponse] = await postChannel(
        { path, body, params },
        {
          cancelToken: source.token,
        },
      );

      return mergeChannelWithUserData(channelResponse, channelUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return !(
        state.channels.channels.channel.actions.create.request[
          generateStreamCIDKey(path)
        ]?.loading === REQUEST.pending
      );
    },
  },
);

export const createChannelExtraReducers = builder => {
  builder
    .addCase(createChannel.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.channel.actions.create.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(createChannel.fulfilled, (state, action) => {
      onMatchedRequest(
        state.channels.channel.actions.create.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
        () => {
          const channelCIDKey = generateChannelCIDKey(action.payload);

          state.channels.channel.byId[channelCIDKey] = action.payload;
          state.channels.channel.allIds.push(channelCIDKey);
        },
      );
    })
    .addCase(createChannel.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.channel.actions.create.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
